<template>
    <div v-if="dataIsLoaded" class="min-w-screen min-h-screen flex items-center justify-center">
        <div v-if="tokenIsValid">
            <div v-if="accountIsAlreadyConfirmed" class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
                <p class="text-center">Ваш аккаунт уже подтвержден</p>
            </div>
            <div v-else class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
                <form @submit.prevent="createPassword">
                    <p class="text-2xl mb-8">Создайте пароль</p>
                    <div class="mb-4">
                        <PasswordInput v-model:passwordParam="password" labelContent="Пароль" ref="passwordInput" class="mb-2"/>
                        <p v-if="!passwordIsValid" :class="invalidInputedPassword ? 'text-red-500' : ''" class="text-sm">Пароль должен содержать минимум 8 символов, числа, заглавные и строчные буквы на латинице</p>
                    </div>
                    <div class="mb-6">
                        <PasswordInput v-model:passwordParam="passwordConfirmation" labelContent="Подтверждение пароля" ref="passwordConfirmationInput" class="mb-6"/>
                        <p v-if="!passwordIsMatched" :class="inputedPasswordsIsMismatch ? 'text-red-500' : ''" class="text-sm">Пароли не совпадают</p>
                    </div>
                    <button type="submit" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-8">Создать</button>
                </form>
            </div>
        </div>
        <div v-else class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <p class="text-center">Похоже ссылка устарела</p>
            <p class="text-center">Попробуйте запросить письмо еще раз</p>
        </div>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';
    import PasswordInput from '@/components/InputComponents/PasswordInput.vue';

    export default {
        name: "AccountConfirmation",
        components: {
            LoadingComponent, 
            PasswordInput,
        },
        computed: {
            ...mapState(["profileData"]),
            passwordIsValid() {
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
                if (!passwordRegex.test(this.password)) {
                    return false;
                }
                return true;
            },
            passwordIsMatched() {
                return this.password == this.passwordConfirmation;
            },
        },
        data() {
            return {
                password: null,
                passwordConfirmation: null,
                tokenIsValid: false,
                dataIsLoaded: false,
                token: null,
                accountIsAlreadyConfirmed: false,
                invalidInputedPassword: false,
                inputedPasswordsIsMismatch: false,
            }
        },
        methods: {
            async checkToken() {
                const token = this.$route.query.token;
                if (!token) {
                    this.dataIsLoaded = true;
                    return;
                }

                const result = await this.$store.dispatch("checkTokenToConfirmAccount", token);
                if (result.successfully) {
                    this.tokenIsValid = true;
                    if (result.result == "Already done.") {
                        this.accountIsAlreadyConfirmed = true;
                    }
                }
                this.token = token;
                this.dataIsLoaded = true;
            },
            validateData() {
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
                if (!this.password) {
                    const passwordInput = this.$refs.passwordInput.$refs.passwordInput;
                    passwordInput.setCustomValidity("Придуймате пароль для аккаунта");
                    passwordInput.reportValidity();
                    this.invalidInputedPassword = true;
                    return false;
                }
                if (!passwordRegex.test(this.password)) {
                    const passwordInput = this.$refs.passwordInput.$refs.passwordInput;
                    passwordInput.setCustomValidity("Пароль должен состоять минимум из 8 символов и содержать числа, заглавные и строчные буквы");
                    passwordInput.reportValidity();
                    this.invalidInputedPassword = true;
                    return false;
                }
                if (this.password != this.passwordConfirmation) {
                    const passwordConfirmationInput = this.$refs.passwordConfirmationInput.$refs.passwordInput;
                    passwordConfirmationInput.setCustomValidity("Пароли не совпадают")
                    passwordConfirmationInput.reportValidity();
                    this.inputedPasswordsIsMismatch = true;
                    return false;
                }
                this.inputedPasswordsIsMismatch = false;
                this.invalidInputedPassword = false;
                return true;
            },
            async createPassword() {
                if (!this.validateData()) {
                    return;
                }
                const data = {
                    temporary_token: this.token,
                    password: this.password,
                }
                let result = await this.$store.dispatch("confirmAccount", data);
                if (result.successfully) {
                    result = await this.$store.dispatch("fetchProfileData");
                    this.$router.push({name: "role"})
                }
            }
        },
        created() {
            this.checkToken();
        }
    }
</script>